export default "__VITE_ASSET__bba30542__"